import axios from "axios";
import nCodeMetricsMock from '../assets/ncode_metrics_sample.json';

export interface NCodeMetricsBreakdown {
  completion: {
    totalRequests: number;
    totalSuggested: number;
    totalAccepted: number;
  };
  explanation: {
    totalRequests: number;
  };
  documentation: {
    totalRequests: number;
  };
  testcase: {
    totalRequests: number;
    totalSuggested: number;
  };
}

export interface NCodeMetrics {
  totalRequests: number;
  totalSuggested: number;
  totalAccepted: number;
  breakdown: NCodeMetricsBreakdown;
}

const API_URL = process.env.VUE_APP_NCODE_API || 'http://34.107.134.30/api'; // Fallback to default URL if env variable is not set
const USE_MOCK_DATA = false; // Toggle for mock data

const headers = {
  Accept: "application/json",
  Authorization: `Bearer your-token-here` // Hardcoded token
};

export const fetchNCodeMetrics = async (): Promise<NCodeMetrics> => {
  let response;
  let metricsData;

  if (USE_MOCK_DATA) {
    console.log("Using mock data for nCode metrics");
    metricsData = nCodeMetricsMock;
  } else {
    const secretKey = process.env.VUE_APP_NCODE_METRICS_SECRET_KEY; // Access the secret key from the environment

    if (!secretKey) {
      throw new Error("VUE_APP_NCODE_METRICS_SECRET_KEY is not defined in the environment variables");
    }

    response = await axios.post(
      `${API_URL}/aggregateMetric`,
      {
        secretKey
      },
      {
        headers: {
          "Content-Type": "application/json",
          ...headers // Include any additional headers you might have
        }
      }
    );
    metricsData = response.data;
  }

  return metricsData;
};

// New function to get all users
export const fetchAllUsers = async (): Promise<any> => {
  const secretKey = process.env.VUE_APP_NCODE_METRICS_SECRET_KEY; // Access the secret key from the environment

  if (!secretKey) {
    throw new Error("VUE_APP_NCODE_METRICS_SECRET_KEY is not defined in the environment variables");
  }

  const response = await axios.post(
    `${API_URL}/users`,
    {
      secretKey
    },
    {
      headers: {
        "Content-Type": "application/json",
        ...headers // Include any additional headers you might have
      }
    }
  );

  return response.data.data;
}; 